import React from 'react'
import {RowOptions} from '@components/common/base/table/types'
import {RowData} from '@components/timeline-new/types'
import {ColumnProps} from './types'

export const column =
  (Component: React.FunctionComponent<ColumnProps>) =>
  (item: RowData, options: RowOptions): React.ReactNode => (
    <Component item={item} options={options} />
  )
